const SEPARATORS = [" – ", " - ", " — "];

export function stripAirframePrefix(name: string, airframe: string): string {
  for (const separator of SEPARATORS) {
    const prefix = `${airframe}${separator}`;
    if (name.startsWith(prefix) && name.length > prefix.length) return name.slice(prefix.length);
  }
  return name;
}

export function stripAirframeLabel(name: string): string {
  const i = name.indexOf(" – ");
  return i > 0 && i + 3 < name.length ? name.slice(i + 3) : name;
}

export function shortTierLabel(label: string): string {
  return label.replace(/\s+Proficiency$/i, "");
}
